import {
  Button,
  CircularProgress,
  Container,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { url } from "../../baseUrl";
import { useSelector } from "react-redux";
import axios from "axios";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import {
  brandName,
  cardBackground,
  currency,
  darkBackground,
  darkGradient,
  darkText,
  invoiceCard,
  lightBackground,
  lightBorder,
  lightText,
  navbar,
  white,
} from "../../Assets/Theme/ThemeColors";
import CustomizedSnackbars from "../../Components/SnackBar/SnackBar";

import "./invoice.css";
import StripeCardForm from "../../Components/StripeCardForm/StripeCardForm";
import logo from "../../Assets/images/logo.png";
import stripeBadge from "../../Assets/images/stripebadge.png";

const InvoicePage = () => {
  let { id } = useParams();
  let param = id.split("_");

  const [data, setData] = useState();
  const [key, setKey] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isPaid, setIsPaid] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [isLoaded, setIsLoaded] = useState(false);

  let invoiceId = param[0];
  console.log("invoiceId", invoiceId);

  var formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency,
  });

  useEffect(() => {
    getSpecificTransaction();
  }, []);

  const getSpecificTransaction = async () => {
    setIsLoading(false);
    await axios
      .post(`${url}/transactions/getSpecificTransaction`, {
        _id: invoiceId,
      })
      .then((response) => {
        console.log("response", response.data.data[0]);
        setData(response.data.data[0]);
        console.log("key", response.data.key.publishKey);
        setKey(response.data.key.publishKey);

        if (response.data.data[0].paymentStatus) {
          setIsPaid(true);
        } else {
          setIsPaid(false);
        }
        setIsLoading(true);
      });
  };
  console.log("data", data);
  return (
    <Grid
     style={{
      background :`${darkGradient}`  }}
     >
      {isLoading ? (
        <>
          {/* navbar */}
          <Grid
            container
            xs={12}
            sx={{
              height: "8vh",
            }}
          >
            <Grid
              item
              md={3}
              xs={12}
              sx={{
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: darkBackground,
                position: "fixed",
                height: "max-content",
                left: 0,
                right: 0,
                top: { md: "50px", xs: "30px" },
                width: "max-content",
                boxShadow: "0 0 3px rgb(0 0 0 / 7%)",
                padding: "5px 35px",
                borderRadius: "60px",
                margin: "auto",
                zIndex: "1",
              }}
            >
              <img src={logo} height="auto" width="190px" alt="logo"></img>
            </Grid>
          </Grid>
          {/* content */}
          <Grid
            container
            style={{
              maxWidth: "100vw",
              height: "80%",
              // background: `${mainBackgound}`,

              display: "flex",
              alignItems: "center",
              flexFlow: "column",
              fontFamily: "Roboto",
              // background :`${darkGradient}`
              // backgroundImage: `url(${contentImg})`,
              // backgroundSize: "70%", // This ensures the image covers the entire background
              // backgroundPosition: "center", // This centers the image
              // backgroundRepeat: "no-repeat",
            }}
            sx={{ pt: 3, pl: 3, pr: 3 }}
          >
            {/* invoice section */}
            <Grid item md={5} xs={12}>
              <Paper
                sx={{
                  background: `${cardBackground}`,
                  //   color: `${mainBackgound}`,
                  p: 3,
                  marginTop: { md: "120px", xs: "60px" },
                  borderRadius: "30px",
                }}
              >
                <Grid container>
                  <Grid item className="row" container>
                    {" "}
                    <Grid
                      xs={12}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        pr: 2,
                      }}
                    >
                      {/* <Typography variant="h6" display="block" gutterBottom>
                        {data.brand}
                      </Typography> */}

                      {/* <img
                        src={logo2}
                        height="40px" width="160px"
                        alt="logo"
                      ></img> */}
                    </Grid>{" "}
                    {/* <Grid
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                      xs={12}
                    >
                      <Typography variant="h6">OrderID</Typography>
                    </Grid>{" "} */}
                  </Grid>
                  <Grid item className="row" container>
                    {" "}
                    <Grid
                      sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                        mb: 1,
                      }}
                      xs={12}
                    >
                      <Typography
                        variant="body2"
                        gutterBottom
                        component="div"
                        style={{
                          background: `${navbar}`,
                          color: `${white}`,
                          padding: "5px 15px 5px 15px",
                          borderRadius: "40px",
                        }}
                      >
                        ORDER ID : {data.orderId}
                      </Typography>
                    </Grid>{" "}
                  </Grid>

                  <Grid item className="row" container>
                    {" "}
                    <Grid
                      sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                        color: `${darkText}`,
                      }}
                      xs={12}
                    >
                      <Typography variant="body2" gutterBottom component="div">
                        <b>INVOICE TO : {data.custName}</b>
                      </Typography>
                    </Grid>{" "}
                  </Grid>
                  <Grid item className="row" container>
                    {" "}
                    {/* <Grid
                      xs={6}
                      sx={{ display: "flex", justifyContent: "flex-start" }}
                    >
                      Phone : 09876543
                    </Grid>{" "} */}
                    <Grid
                      sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                        color: `${darkText}`,
                      }}
                      xs={12}
                    >
                      <Typography variant="body2" gutterBottom component="div">
                        <b>PHONE : {data.custContactNumber}</b>
                      </Typography>
                    </Grid>{" "}
                  </Grid>
                  <Grid item className="row" container>
                    {" "}
                    {/* <Grid
                      xs={6}
                      sx={{ display: "flex", justifyContent: "flex-start" }}
                    >
                      website : CyberClosses.com
                    </Grid>{" "} */}
                    <Grid
                      sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                        color: `${darkText}`,
                      }}
                      xs={12}
                    >
                      <Typography variant="body2" gutterBottom component="div">
                        <b>EMAIL : {data.custEmail}</b>
                      </Typography>
                    </Grid>{" "}
                  </Grid>
                  <Grid item className="row" container>
                    {" "}
                    {/* <Grid
                      xs={6}
                      sx={{ display: "flex", justifyContent: "flex-start" }}
                    >
                      Email : abc@gmail.com
                    </Grid>{" "} */}
                    <Grid
                      sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                        color: `${darkText}`,
                      }}
                      xs={12}
                    >
                      <Typography variant="body2" gutterBottom component="div">
                        <b>DATE : {data.dateTime.split(",")[0]}</b>
                      </Typography>
                    </Grid>{" "}
                  </Grid>
                </Grid>

                {/* descrription */}
                <Grid
                  container
                  sx={{
                    background: `${invoiceCard}`,
                    p: 1,
                    borderRadius: "20px",
                    color: `${white}`,
                    mt: 2,
                  }}
                >
                  <Grid
                    item
                    className="row"
                    container
                    sx={{
                      // background: `${invoiceCard}`,
                      // color: `${darkText}`,
                      borderRadius: "3px",
                      p: 1,
                      borderBottom: `1px solid ${lightBorder}`,
                    }}
                  >
                    {" "}
                    <Grid
                      xs={10}
                      sx={{ display: "flex", justifyContent: "flex-start" }}
                    >
                      <Typography
                        variant="subtitle2"
                        gutterBottom
                        component="div"
                        sx={{
                          height: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItem: "center",
                        }}
                      >
                        Description
                      </Typography>
                    </Grid>{" "}
                    <Grid
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                      xs={2}
                    >
                      <Typography
                        variant="subtitle2"
                        gutterBottom
                        component="div"
                        sx={{
                          height: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItem: "center",
                        }}
                      >
                        Amount
                      </Typography>
                    </Grid>{" "}
                  </Grid>
                  <Grid item className="row" container sx={{ p: 1 }}>
                    {" "}
                    <Grid
                      xs={10}
                      sx={{ display: "flex", justifyContent: "flex-start" }}
                    >
                      <Typography variant="body2">
                        {data.discription}
                      </Typography>
                    </Grid>{" "}
                    <Grid
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                      xs={2}
                    >
                      <Typography variant="body2">
                        {formatter.format(data.amount)}
                      </Typography>
                    </Grid>{" "}
                  </Grid>
                  <Grid item className="row" container sx={{ p: 1 }}>
                    {" "}
                    <Grid xs={1}></Grid>
                    <Grid
                      xs={9}
                      sx={{ display: "flex", justifyContent: "flex-start" }}
                    >
                      <Typography
                        textAlign={"left"}
                        variant="body2"
                        gutterBottom
                      >
                        - {data.detailDiscription}
                      </Typography>
                    </Grid>{" "}
                    <Grid xs={4}></Grid>{" "}
                  </Grid>
                  <Grid item className="row" container sx={{ p: 1 }}>
                    {" "}
                    <Grid
                      xs={10}
                      sx={{ display: "flex", justifyContent: "flex-start" }}
                    >
                      <Typography variant="body2">
                        Additional Discount
                      </Typography>
                    </Grid>{" "}
                    <Grid
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                      xs={2}
                    >
                      <Typography variant="body2">
                        -{formatter.format(data.discount)}
                      </Typography>
                    </Grid>{" "}
                  </Grid>
                  <Grid item className="row" container sx={{ p: 1 }}>
                    {" "}
                    <Grid
                      xs={10}
                      sx={{ display: "flex", justifyContent: "flex-start" }}
                    >
                      <Typography variant="body2">Taxes and Fees</Typography>
                    </Grid>{" "}
                    <Grid
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                      xs={2}
                    >
                      <Typography variant="body2">
                        {formatter.format(data.additionalCharges)}
                      </Typography>
                    </Grid>{" "}
                  </Grid>
                  <Grid item className="row" container sx={{ p: 1 }}>
                    {" "}
                    <Grid
                      xs={10}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                        borderTop: `1px solid ${lightBorder}`,
                        pt: 1,
                      }}
                    >
                      <Typography variant="body2" display="block" gutterBottom>
                        <b>PAYABLE AMOUNT</b>
                      </Typography>
                    </Grid>{" "}
                    <Grid
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        borderTop: `1px solid ${lightBorder}`,
                        pt: 1,
                      }}
                      xs={2}
                    >
                      <Typography variant="body2" display="block" gutterBottom>
                        <b>{formatter.format(data.total)}</b>
                      </Typography>
                    </Grid>{" "}
                  </Grid>
                </Grid>
              </Paper>
            </Grid>

            {/* card section */}
            <Grid
              container
              style={{
                marginTop: "20px",
                display: "flex",
                justifyContent: "center",
                // alignItems: "center",
              }}
            >
              <Grid
                item
                md={4}
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexFlow: "column",
                }}
              >
                <Grid xs={12}>
                  <Typography
                    variant="h5"
                    sx={{
                      color: `${white}`,
                      textAlign: "center",
                      paddingTop: "25px",
                      fontWeight: "300px !important",
                    }}
                  >
                    JUST ONE STEP LEFT
                  </Typography>
                  <Typography
                    variant="h5"
                    sx={{
                      color: `${white}`,
                      textAlign: "center",
                      paddingTop: "5px",
                      marginBottom: "20px",
                    }}
                  >
                    TO COMPLETE YOUR PAYMENT
                  </Typography>

                  <Typography
                    variant="h8"
                    sx={{
                      color: `${darkText}`,
                      textAlign: "center",
                      paddingTop: "10px",
                      marginTop: "20px",
                    }}
                  >
                    We're almost done here, just a few more things that we'd be
                    needing from you to welcome you onboard.
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{
                      color: `${white}`,
                      textAlign: "center",
                      paddingTop: "15px",
                      paddingBottom: "15px",
                    }}
                  >
                    Secure Payment Globally!
                  </Typography>
                </Grid>
                <Paper
                  item
                  md={6}
                  xs={10}
                  sx={{
                    height: "100%",
                    width: "100%",
                    background: `${cardBackground}`,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexFlow: "column",
                    borderRadius: "30px",
                    padding: "0",
                  }}
                >
                  <Grid
                    container
                    sx={{
                      maxHeight: "50px",
                      color: `${darkText}`,
                      display: "flex",
                      justifyContent: "center",
                      alighItems: "center",
                      borderBottom: `1px solid ${lightBorder}`,
                      padding: "20px 20px 35px 20px",
                    }}
                  >
                    {" "}
                    <Grid
                      item
                      container
                      xs={12}
                      sx={{
                        display: "flex",
                        alighItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography variant="subtitle2">AMOUNT</Typography>{" "}
                      <Typography variant="subtitle2">
                        {formatter.format(data.total)}
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sx={{
                      p: 4,
                      pt: 2,
                      // display: "flex",
                      // justifyContent: "center",
                      // alignItems: "center",
                    }}
                  >
                    {isPaid ? (
                      <Typography
                        variant="h5"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          background: "green",
                          color: "white",
                          padding: "20px",
                          borderRadius: "5px",
                        }}
                      >
                        <TaskAltIcon />
                        &nbsp; Already Paid
                      </Typography>
                    ) : (
                      <StripeCardForm
                        transactionId={invoiceId}
                        amount={Number(data.total)}
                        account={data.account}
                        stripeKey={key}
                      />
                    )}

                    <Grid sx={{ pt: 1 }}>
                      <img
                        src={stripeBadge}
                        height="100%"
                        width="100%"
                        alt="logo"
                      ></img>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          </Grid>
       
          {/* footer */}
          <Grid container 
          sx={{background:"none"}}
          >
            <Grid xs={1}></Grid>
            <Grid
              xs={10}
              sx={{
                background: `${navbar}`,
                color: `${white}`,
                height: { md: "70px", xs: "50px" },
                borderRadius: "50px",
                margin: { md: "70px 0 50px 0", xs: "50px 0 30px 0" },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: { md: "space-between", xs: "center" },
                  alignItems: "center",
                  height: "100%",
                  padding: { md: "0 20px", xs: "0px 0px" },
                  flexWrap: "wrap",
                }}
              >
                <Box>
                  <Typography variant="body2" style={{ color: `${white}` }}>
                    Copyright ©{brandName} {new Date().getFullYear()}. All Right Reserved.
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="body2" style={{ color: `${white}` }}>
                  Privacy Policy | Terms And Condition
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid xs={1}></Grid>
          </Grid>
        </>
      ) : (
        <>
          <Typography
            variant="h5"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {" "}
            <CircularProgress />
            LOADING
          </Typography>
        </>
      )}
      <CustomizedSnackbars
        isOpen={isOpen}
        severity={severity}
        message={message}
      />
    </Grid>
  );
};

export default InvoicePage;